import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMissing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <circle
      cx={8}
      cy={8}
      r={6.525}
      stroke="#CBCBCB"
      strokeDasharray="0.56 4.5"
      strokeLinecap="round"
      strokeWidth={1.688}
    />
  </svg>
);
export default SvgMissing;
